export default {
    searchText: 'ค้นหาชื่อวันทำงานพิเศษ',
    search: 'ค้นหา',
    specialWorkdayName: 'ชื่อวันทำงานพิเศษ',
    createdDate: 'วันที่สร้าง',
    workDate: 'วันที่ทำงาน',
    startEndTime: 'เวลาเริ่ม - สิ้นสุด',
    bureau: 'สำนักงาน',
    action: '',
    addSpecialWorkday: 'สร้างวันทำงานพิเศษ',
    deleteHeader: 'ลบวันทำงานพิเศษ',
    wantToDelete: 'คุณเเน่ใจว่าต้องการที่จะลบวันทำงานพิเศษ',
    congratulation: 'ยินดีด้วย',
    deletedSpecialWorkday: 'วันทำงานพิเศษถูกลบแล้ว'
}
